import { render, staticRenderFns } from "./RolesModal.vue?vue&type=template&id=b4e61af4&scoped=true"
import script from "./RolesModal.vue?vue&type=script&lang=js"
export * from "./RolesModal.vue?vue&type=script&lang=js"
import style0 from "./RolesModal.vue?vue&type=style&index=0&id=b4e61af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e61af4",
  null
  
)

export default component.exports